import React, { useState } from 'react';
import { useApplicationState } from '../../../state/ApplicationContext';
import { TextField } from '../../form/TextField';
import { FieldGrid } from '../../form/FieldGrid';
import { Edit2Icon, CheckIcon } from 'lucide-react';
export function CrmHeader() {
  const {
    state,
    dispatch
  } = useApplicationState();
  const [isEditing, setIsEditing] = useState(false);
  const {
    crm
  } = state;
  const handleChange = (field: keyof typeof crm, value: string) => {
    dispatch({
      type: 'UPDATE_CRM',
      payload: {
        [field]: value
      }
    });
  };
  return <div className="bg-white border-b border-gray-200 px-4 py-4 lg:px-8 shadow-sm" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="flex items-center justify-between mb-2" data-id="element-76">
          <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider" data-id="element-77">
            Application Details
          </h3>
          <button onClick={() => setIsEditing(!isEditing)} className="flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700" data-id="element-78">
            {isEditing ? <CheckIcon className="w-4 h-4" data-id="element-79" /> : <Edit2Icon className="w-4 h-4" data-id="element-80" />}
            {isEditing ? 'Done' : 'Override'}
          </button>
        </div>

        {isEditing ? <div className="mt-4 bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-81">
            <FieldGrid data-id="element-82">
              <TextField label="Loan Officer" value={crm.loanOfficer} onChange={v => handleChange('loanOfficer', v)} data-id="element-83" />
              <TextField label="Loan Partner" value={crm.loanPartner} onChange={v => handleChange('loanPartner', v)} data-id="element-84" />
              <TextField label="Lead Source" value={crm.leadSource} onChange={v => handleChange('leadSource', v)} data-id="element-85" />
              <TextField label="Campaign" value={crm.campaign} onChange={v => handleChange('campaign', v)} data-id="element-86" />
            </FieldGrid>
          </div> : <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600" data-id="element-87">
            <div data-id="element-88">
              <span className="font-medium text-gray-900" data-id="element-89">LO:</span>{' '}
              {crm.loanOfficer}
            </div>
            <div data-id="element-90">
              <span className="font-medium text-gray-900" data-id="element-91">Partner:</span>{' '}
              {crm.loanPartner}
            </div>
            <div data-id="element-92">
              <span className="font-medium text-gray-900" data-id="element-93">Source:</span>{' '}
              {crm.leadSource}
            </div>
            <div data-id="element-94">
              <span className="font-medium text-gray-900" data-id="element-95">Date:</span>{' '}
              {crm.applicationDate}
            </div>
          </div>}
      </div>
    </div>;
}